export default "__VITE_ASSET__ab3331c4__"